import React from 'react';

import { useTheme } from '@bcp-nextgen-dx-component-factory/design-system';

interface RoundIconWarningIconProps {
	exclamationColor?: string;
}

export const RoundIconWarning: React.FC<RoundIconWarningIconProps> = (props) => {
	const { colorPalette } = useTheme();
	const { exclamationColor = colorPalette.color_01[50] } = props;

	return (
		<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z"
				fill="#F5A623"
			/>
			<path
				d="M39.125 49.5431C39.1248 47.8187 37.7241 46.4167 36.0008 46.4167C34.2775 46.4167 32.875 47.8188 32.875 49.5431C32.875 51.2645 34.2775 52.6667 36.0008 52.6667C37.7241 52.6667 39.125 51.2645 39.125 49.5431Z"
				fill={exclamationColor}
			/>
			<path
				d="M36 19.3333C34.2741 19.3333 32.875 20.5404 32.875 22.0294L32.875 40.5956C32.875 42.0846 34.2741 43.2916 36 43.2916C37.7259 43.2916 39.125 42.0846 39.125 40.5956L39.125 22.0294C39.125 20.5404 37.7259 19.3333 36 19.3333Z"
				fill={exclamationColor}
			/>
		</svg>
	);
};
